import { z } from 'zod'
import { createClient } from '@/shared/api/client'
import { buildUrl } from '@/shared/utils/urls'
import { TargetSystem } from '@/shared/constants'
import { validateResponseHasSchema, validateResponseIsOk } from '@/shared/api/validation'

const client = createClient(buildUrl(TargetSystem.CoreApi))

export const startOAuth = () => validateResponseHasSchema(
  validateResponseIsOk(
    client.sendPost('authentication/oauth')
  ),
  z.object({
    data: z.object({
      redirectUrl: z.string()
    })
  })
)
